import { Loader2 } from "lucide-react";
import type { ReactNode } from "react";
import { useEffect } from "react";
import { useNavigate } from "react-router";
import { useIsOrgAdmin } from "@/lib/admin-utils";
import { authClient } from "@/lib/auth-client";

export function OrgAdminRoute({ children }: { children: ReactNode }) {
  const { data: session, isPending } = authClient.useSession();
  const isOrgAdmin = useIsOrgAdmin();
  const navigate = useNavigate();

  const hasAccess = isOrgAdmin;

  useEffect(() => {
    if (!(isPending || session)) {
      navigate("/auth/restaurant/sign-in");
    } else if (!isPending && session && !hasAccess) {
      navigate("/");
    }
  }, [session, isPending, hasAccess, navigate]);

  if (isPending) {
    return (
      <div className="flex h-screen w-full items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin" />
      </div>
    );
  }

  if (session && hasAccess) {
    return <>{children}</>;
  }

  return null;
}
